<div class="link-wrapper">
  <p>Select links below and read</p>
  <ul class="links">
    <li class="link" *ngFor="let link of to.links">
      <a [routerLink]="link.link">{{ link.title }}</a>
    </li>
  </ul>
  <ng-container #fieldComponent></ng-container>
</div>
